import type { FC } from 'react';
import { SchemaIcon } from './schema-display';
import { schemaTintStyle } from './schema-theming';
import type { FieldConditionSubject } from './segment-builder.types';
import styles from './SegmentVisualBuilder.module.css';

interface SchemaNameChipProps {
  subject: FieldConditionSubject;
  /** Set to 0 only when an ancestor wraps the chip in a tooltip that needs a focusable trigger. */
  tabIndex?: number;
}

/** Carries its own `--schema-color` so a chip can name a different schema than the block around it. */
export const SchemaNameChip: FC<SchemaNameChipProps> = ({ subject, tabIndex }) => (
  <span
    className={styles.objectChip}
    style={schemaTintStyle(subject.displayMetadata)}
    tabIndex={tabIndex}>
    <SchemaIcon displayMetadata={subject.displayMetadata} size={13} />
    <span className={styles.objectChipName}>{subject.name}</span>
  </span>
);
